import {useCallback} from 'react';
import {useLocation} from '@reach/router';

export const useContactMutation = () => {
  const location = useLocation();

  return useCallback(
    data => {
      const portalId = process.env.GATSBY_HUBSPOT_ID;
      const formGuid = process.env.GATSBY_HUBSPOT_CONTACT_FORM_ID;

      const hutk = document.cookie.replace(/(?:(?:^|.*;\s*)hubspotutk\s*\=\s*([^;]*).*$)|^.*$/, '$1');
      const pageUri = location.pathname + location.search + location.hash;

      const context = {
        pageUri,
      };

      if (hutk) {
        context.hutk = hutk;
      }

      const payload = {
        portalId,
        formGuid,
        fields: [
          {
            name: 'firstname',
            value: data.firstname,
          },
          {
            name: 'lastname',
            value: data.lastname,
          },
          {
            name: 'email',
            value: data.email,
          },
          {
            name: 'mobilephone',
            value: data.phone,
          },
          {
            name: 'message',
            value: data.message,
          },
          {
            name: 'contact_source',
            value: 'Website Enquiry',
          },
        ],
        context,
      };

      return fetch(`https://api.hsforms.com/submissions/v3/integration/submit/${portalId}/${formGuid}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        mode: 'cors',
        credentials: 'omit',
        body: JSON.stringify(payload),
      }).then(response => {
        if (response.ok) {
          return response.json();
        } else {
          console.error(response);
          throw new Error('Something went wrong');
        }
      });
    },
    [location]
  );
};
